import { useEffect, useState } from "react";
import LoadingView from "../../components/LoadingView";
import ErrorView from "../../components/ErrorView";
import { Heading } from "../../design/heading";
import { useHolidaySchedule } from "../../contexts/HolidayScheduleContext";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { Text } from "../../design/text";
import { HolidayRulesEditor } from "./components/HolidayRulesEditor/HolidayRulesEditor";
import DeleteHolidayScheduleButton from "../../components/DeleteHolidaySchedule";
import HolidayScheduleStatusBadge from "../../components/HolidayScheduleStatusBadge";
import HolidayScheduleButton from "../../components/HolidayScheduleButton";
import HolidayScheduleLiveButton from "./components/HolidayScheduleLiveButton";
import { Navbar, NavbarItem } from "../../design/navbar";
import FileViewer from "../../components/FileViewer";
import { HolidayScheduleService } from "../../services/HolidayScheduleService";
import HolidayScheduleDocument from "./components/HolidayScheduleDocument";

const HolidayScheduleDetailPage = () => {
  const { holidayScheduleId } = useParams<{ holidayScheduleId: string }>();
  const navigate = useNavigate();
  const {
    loading,
    error,
    selectedHolidaySchedule,
    setSelectedHolidaySchedule,
  } = useHolidaySchedule();
  const [state, setState] = useState<"Rules" | "Document">("Rules");

  useEffect(() => {
    if (holidayScheduleId) {
      setSelectedHolidaySchedule(holidayScheduleId);
    }
  }, [holidayScheduleId]);

  if (loading.details) return <LoadingView title="Loading Holiday Schedule" />;
  if (error.details) return <ErrorView error={error.details} />;
  if (!selectedHolidaySchedule)
    return <ErrorView error={new Error("Holiday Schedule not found")} />;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <div className="flex items-center gap-2">
            <Heading>{selectedHolidaySchedule?.name}</Heading>
            <HolidayScheduleStatusBadge
              status={selectedHolidaySchedule?.status}
            />
          </div>
          {selectedHolidaySchedule?.updatedAt && (
            <Text>
              {moment(selectedHolidaySchedule.updatedAt).format("MMM D, YYYY")}
            </Text>
          )}
        </div>
        <div>
          <HolidayScheduleLiveButton
            holidaySchedule={selectedHolidaySchedule}
          />
          <HolidayScheduleButton schedule={selectedHolidaySchedule} />
          <DeleteHolidayScheduleButton
            holidayScheduleId={selectedHolidaySchedule._id}
            onDelete={() => navigate("/holiday-schedule")}
          />
        </div>
      </div>

      <Navbar className="mb-4">
        {(["Rules", "Document"] as const).map((item) => (
          <NavbarItem
            key={item}
            className="text-base"
            onClick={() => setState(item)}
            current={state === item}
          >
            {item}
          </NavbarItem>
        ))}
      </Navbar>
      {state === "Document" && (
        <HolidayScheduleDocument holidaySchedule={selectedHolidaySchedule} />
      )}
      {state === "Rules" && (
        <HolidayRulesEditor holidaySchedule={selectedHolidaySchedule} />
      )}
    </div>
  );
};

export default HolidayScheduleDetailPage;
